import { useEffect } from "react"

export default function useDoneTyping({ doneTyping }) {
  let typingTimer // timer identifier
  const doneTypingInterval = 500 //time in ms, 1 second for example

  function handleKeyUp() {
    clearTimeout(typingTimer)
    typingTimer = setTimeout(doneTyping, doneTypingInterval)
  }

  function handleKeyDown() {
    clearTimeout(typingTimer)
  }
  useEffect(() => {
    // Clear the timeout whenever the component unmounts
    return function cleanup() {
      clearTimeout(typingTimer)
    }
  }, [typingTimer])
  return { onKeyUp: handleKeyUp, onKeyDown: handleKeyDown }
}

useDoneTyping.defaultProps = {
  interval: 1000,
}
